module.exports = __webpack_public_path__ + "static/media/Group3.46c30d30.svg";